import {gql} from '@apollo/client'

export const GET_ALL_PRODUCTS = gql`
  query productList($after: String, $id: Float, $name: String) {
    productList(after: $after, id: $id, name_Iexact: $name) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          unitPrice
          unitType
          promotion
        }
      }
    }
  }
`
